<template lang="html">

  <footer class="footer">

    <div class="top row-start container">

      <div class="footer-part row-start ais">
        <h4>{{$t('mapa_web.sobrefiesta')}}</h4>
        <router-link :to="$t('enlaces.metelefiesta')">{{$t('metelefiesta.nombre')}}</router-link>
        <router-link :to="$t('enlaces.fiestahoy')">{{$t('fiestahoy.titulo')}}</router-link>
        <router-link :to="$t('enlaces.historia')">{{$t('historia.titulo')}}</router-link>
        <router-link :to="$t('enlaces.fiestamundo')">{{$t('fiestamundo.titulosmall')}}</router-link>
        <router-link :to="$t('enlaces.calidad')">{{$t('calidad.titulo')}}</router-link>
        <router-link :to="$t('enlaces.distribucion')">{{$t('distribucion.titulo')}}</router-link>
        <!-- <router-link :to="$t('enlaces.diselopiruletas')">{{$t('diselopiruletas.titulo')}}</router-link> -->
        <router-link :to="$t('enlaces.alergeno')">{{$t('alergenos.titulo')}}</router-link>
        <a  target="_blank" href="/static/informe-sostenibilidad.pdf">Informe de sostenibilidad </a>

        <!-- <router-link :to="$t('enlaces.faqs')">{{$t('faqs.titulo')}}</router-link> -->
      </div>

      <div class="footer-part -small row-start">
        <h4>{{$t('mapa_web.lomastop')}}</h4>
        <router-link :to="$t('enlaces.productos')">{{$t('productos.titulo')}}</router-link>
        <router-link v-if="!!promociones && promociones.length != 0" :to="$t('enlaces.promociones')">{{$t('promociones.titulo')}}</router-link>
        <router-link v-if="!!noticias && noticias.length != 0" :to="$t('enlaces.novedades')">{{$t('novedades.titulo')}}</router-link>
      </div>
      
      
      <div class="footer-part -small row-start">
        <h4>{{$t('mapa_web.contacta')}}</h4>
        <router-link :to="$t('enlaces.contacto')">{{$t('contacto.titulo')}}</router-link>
        <router-link :to="$t('enlaces.trabaja_con_nosotros')">{{$t('trabaja.titulo')}}</router-link>
        <router-link :to="$t('enlaces.sala_de_prensa')">{{$t('saladeprensa.titulo')}}</router-link>
        <router-link :to="{ name: 'contacto', query: { departament: $t('calidad_reclamaciones.query')}}">{{ $t('calidad_reclamaciones.titulo') }}</router-link>
      </div>

      <idioma></idioma>

    </div>

    <div class="bottom">
      <div class="container-footer bottom-container row-between">
        <div class="left">
          <nav class="row-start">
            <router-link :to="$t('enlaces.politica_privacidad')">{{$t('politica.titulo')}}</router-link>
            <router-link :to="$t('enlaces.politica_cookies')">{{$t('cookies.titulo')}}</router-link>
            <router-link :to="$t('enlaces.aviso_legal')">{{$t('aviso_legal.titulo')}}</router-link>
            <router-link :to="$t('enlaces.mapa_web')">{{$t('mapa_web.titulo')}}</router-link>
            <a :href="$t('enlaces.canal_informante')" target="_blank">{{ $t('canal_informante.titulo') }}</a>
          </nav>
        </div>
        <div class="right row-end">
          <nav class="rrss">
            <a class="facebook" href="https://www.facebook.com/Fiesta.ES/" target="_blank"><i class="fa fa-facebook"></i></a>
            <a class="twitter" href="https://twitter.com/FIESTA_es" target="_blank"><i class="fa fa-twitter"></i></a>
            <a class="instagram" href="https://www.instagram.com/fiesta.es/" target="_blank"><i class="fa fa-instagram"></i></a>
            <a class="linkedin" href="https://www.linkedin.com/company/fiesta/" target="_blank"><i class="fa fa-linkedin"></i></a>
            <a class="youtube" href="https://www.youtube.com/channel/UCtRixMwzH403OfMoR3XAPDw" target="_blank"><i class="fa fa-youtube"></i></a>
          </nav>
          <div>
            <a href="https://colombina.com/" target="_blank">
              <img class="logo" src="/static/img/logo-colombina.png" alt="Logo Colombina">
            </a>
            <img class="logo fiesta" src="/static/img/logo-fiesta.svg" alt="Logo Fiesta">
          </div>
        </div>
      </div>
    </div>
    
  </footer>

</template>

<script lang="js">

  import idioma from '@/components/view-parts/footer/idioma'

  import {mapGetters} from 'vuex'

  export default  {
    name: 'app-footer',
    mounted(){
      let pos;
      let prepos;
      window.addEventListener('scroll', e => {
        prepos = pos;
        pos = window.scrollY;
      });
    },
    computed:{
      ...mapGetters({
        version : 'getVersion',
        noticias : 'getNoticias',
        promociones : 'getpromociones'
      })
    },
    components: {
      'idioma' : idioma
    }
}
</script>



// WEBPACK FOOTER //
// src/components/parts/footer.vue